import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastService } from 'src/app/core/toast.service';
import { CategoriaApiService } from 'src/app/dao/api_categoria.service';
import { ApiImpressoraService } from 'src/app/dao/api_impressora.service';
import { Impressora } from 'src/app/model/impressora';

@Component({
  selector: 'app-impressoras',
  templateUrl: './impressoras.page.html',
  styleUrls: ['./impressoras.page.scss'],
  providers: [MessageService, ConfirmationService]
})
export class ImpressorasPage implements OnInit {

  freteDialog: boolean;

  fretes: Impressora[];

  frete: Impressora;

  selectedfretes: Impressora[];

  submitted: boolean;

  ativos;

  tipos = [];

  rotas = [];
  tamanhos = [];

  // tslint:disable-next-line: max-line-length
  constructor(private apiCategoria: CategoriaApiService, private impressoraService: ApiImpressoraService, private toast: ToastService, private confirmationService: ConfirmationService) {}

  async ngOnInit() {
    this.frete = new Impressora();
    this.impressoraService.listarTodas().then(data => this.fretes = data);
    const result = await this.impressoraService.listarTodas();
    this.ativos = [
      {nome:'ATIVO', valor: 1},
      {nome:'INATIVO', valor: 0}
    ]
    this.carregarAtivos();
    this.getTamanhos();
    this.getTipos();
    this.carregarRotas();
  }



  carregarRotas() {
    return this.apiCategoria.getRotas()
      .then(rotas => {
        this.rotas = rotas.map(c => {
          return ({ label: c.descricao_rota, value: c.descricao_rota });
          // tslint:disable-next-line: align
        });
        this.rotas.splice(0,0,{label: "Nenhuma", value: ""})
      })
      
      .catch(erro => {
        this.toast.showError('Erro ao carregar Rotas!');
      });
  }


  carregarAtivos() {
        this.ativos = this.ativos.map(c => {
          return ({ label: c.nome, value: c.valor });
          // tslint:disable-next-line: align
        });
  }

  openNew() {
    // tslint:disable-next-line: new-parens
    this.frete = {};
    this.submitted = false;
    this.freteDialog = true;
  }

  deleteSelectedfretes() {
    this.confirmationService.confirm({
      message: 'Deseja mesmo deletar as Impressoras selecionadas?',
      header: 'Confirmar',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.fretes = this.fretes.filter(val => !this.selectedfretes.includes(val));
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.selectedfretes.length; i++) {
          const result = this.impressoraService.excluir(this.selectedfretes[i].id);
        }
        this.selectedfretes = null;
        this.toast.showSucess('Impressoras Excluídas com Sucesso!');
      }
    });
  }

  editfrete(frete: Impressora) {
    this.frete = {...frete};
    this.freteDialog = true;
  }

  deletefrete(frete: Impressora) {
    this.confirmationService.confirm({
      message: 'Deseja mesmo deletar a Impressora ' + frete.nome + '?',
      header: 'Confirmar',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const result = this.impressoraService.excluir(frete.id);
        this.fretes = this.fretes.filter(val => val.id !== frete.id);
        this.frete = {};
        this.toast.showSucess('Impressora Excluída com Sucesso!');
      }
    });
  }

  hideDialog() {
    this.freteDialog = false;
    this.submitted = false;
  }

 async savefrete() {
    this.submitted = true;
    if (this.frete.nome.trim()) {
      if (this.frete.id) {
        // tslint:disable-next-line: radix
        this.fretes[this.findIndexById(this.frete.id)] = this.frete;
        //this.frete.ativo = true;
        this.impressoraService.atualizar(this.frete);
        this.toast.showSucess('Impressora Atualizada com Sucesso!');
      } else {
        console.log(this.frete);
        const result = await this.impressoraService.adicionar(this.frete);
        this.fretes.push(result);
        this.toast.showSucess('Impressora Cadastrada com Sucesso!');
      }

      this.fretes = [...this.fretes];
      this.freteDialog = false;
      this.frete = {};
    }
  }


  getTamanhos() {
    let statusAux = [
    {name: 'NORMAL', code: 'NORMAL'},
    {name: 'REDUZIDO', code: 'REDUZIDO'}
  ];
  
      this.tamanhos = statusAux.map(c => {
        return ({ label: c.name, value: c.code });
        // tslint:disable-next-line: align
      });
  }



  getTipos() {
    let statusAux = [
    {name: 'PEDIDO', code: 'PEDIDO'},
    {name: 'ORDEM', code: 'ORDEM'}
  ];
  
      this.tipos = statusAux.map(c => {
        return ({ label: c.name, value: c.code });
        // tslint:disable-next-line: align
      });
  }

  findIndexById(id: number): number {
    let index = -1;
    for (let i = 0; i < this.fretes.length; i++) {
      // tslint:disable-next-line: radix
      if (this.fretes[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  }
}
